
import { useAuth } from "@/contexts/AuthContext";

/**
 * Backward compatibility hook to maintain the same API as the old useAuthState hook
 * while using the new centralized AuthContext under the hood.
 */
export const useAuthState = () => {
  const { user, isLoading } = useAuth();
  
  return {
    user,
    isLoading,
  };
};

export default useAuthState;
